module.exports = __webpack_public_path__ + "static/media/polkadot-logo.949f0ce6.png";